export const FINISH_LOADING = 'FINISH_LOADING'
export const SET_ITEMS = 'SET_ITEMS'
export const ADD_ITEM = 'ADD_ITEM'
export const DELETE_ITEM = 'DELETE_ITEM'
export const UPDATE_ITEM = 'UPDATE_ITEM'
export const CLEAR_RECIPES = 'CLEAR_RECIPES'
export const CLEAR_COLLECTIONS = 'CLEAR_COLLECTIONS'
export const REMOVE_RECIPE_IMAGE = 'REMOVE_RECIPE_IMAGE'
export const SET_RECIPE = 'SET_RECIPE'
export const SET_LOCAL_RECIPE_IMAGE_URL = 'SET_LOCAL_RECIPE_IMAGE_URL'
export const DELETE_RECIPE = 'DELETE_RECIPE'
export const RESTORE_RECIPE = 'RESTORE_RECIPE'
export const ADD_COLLECTION_TO_RECIPE = 'ADD_COLLECTION_TO_RECIPE'
export const REMOVE_COLLECTION_FROM_RECIPE = 'REMOVE_COLLECTION_FROM_RECIPE'
export const SET_SCALE = 'SET_SCALE'
export const RESET_SCALE = 'RESET_SCALE'

// Collections
export const SET_COLLECTIONS = 'SET_COLLECTIONS'
export const ADD_TO_COLLECTION = 'ADD_TO_COLLECTION'
export const ADD_COLLECTION = 'ADD_COLLECTION'
export const DESTROY_COLLECTION = 'DESTROY_COLLECTION'
export const REMOVE_FROM_COLLECTION = 'REMOVE_FROM_COLLECTION'
export const UPDATE_COLLECTION = 'UPDATE_COLLECTION'

// Users
export const SET_CLAIMS = 'SET_CLAIMS'
export const SET_USER = 'SET_USER'
export const RESET_USER = 'RESET_USER'
export const SET_FEATURES = 'SET_FEATURES'
export const SET_PREFERENCES = 'SET_PREFERENCES'

// global
export const SET_APP_BAR = 'SET_APP_BAR'
export const SET_HISTORY = 'SET_HISTORY'
export const REMOVE_VIEW_DETAIL = 'REMOVE_VIEW_DETAIL'
export const CLEAR_VIEW = 'CLEAR_VIEW'
export const SET_VIEW = 'SET_VIEW'
export const HIDE_PRIMARY_VIEW = 'HIDE_PRIMARY_VIEW'
export const SHOW_PRIMARY_VIEW = 'SHOW_PRIMARY_VIEW'
export const SET_WINDOW_SIZE = 'SET_WINDOW_SIZE'
export const SET_OBFUSCATOR_VISIBILITY = 'SET_OBFUSCATOR_VISIBILITY'
export const SET_DRAWER_VISIBILITY = 'SET_DRAWER_VISIBILITY'
export const SET_TEMPORARY_VIEW_VISIBILITY = 'SET_TEMPORARY_VIEW_VISIBILITY'
export const SET_COLLECTION_VIEW_STYLE = 'SET_COLLECTION_VIEW_STYLE'
export const ADD_NOTIFICATION = 'ADD_NOTIFICATION'
export const POP_NOTIFICATION = 'POP_NOTIFICATION'
export const TOGGLE_FULLSCREEN = 'TOGGLE_FULLSCREEN'

// shortcuts
export const REGISTER_SHORTCUT = 'REGISTER_SHORTCUT'
export const DEREGISTER_SHORTCUT = 'DEREGISTER_SHORTCUT'

// search
export const ADD_SEARCH = 'ADD_SEARCH'



// WEBPACK FOOTER //
// ./src/modules/mutation-types.js